import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import EditForm from '../../../../../../../features/components/Forms/EditForm'
import MultipleOptionsField from '../../../../../../ReusableFormFields/MultipleOptionsField'

import { getLongHeadlineData } from '../HeadlinesSection/helpers'

import { getInitialValues } from './fields'
import { useEditAssetGroupSubmit } from '../../hooks'

import { selectedGoogleAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { googleAssetFieldType } from '../../../../../../../constants/ads'
import { LONG_HEADLINES_LIST, longHeadlineMaxLength } from '../../../../fields'

const LongHeadlinesSectionForm = ({ editItemData, isInternalAssetGroup, title, ...formProps }) => {
  const { assets, id: assetGroupId, account } = editItemData

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const adAccount = account || selectedAdAccountId

  const originalLongHeadlineAssets = useMemo(() => getLongHeadlineData(assets), [assets])

  const initialValues = useMemo(() => getInitialValues(originalLongHeadlineAssets), [originalLongHeadlineAssets])

  const { purifiedFormik, onClearSubmit, isLoadingSelector, errorSelector, successSubmit } = useEditAssetGroupSubmit({
    originalSectionAssets: originalLongHeadlineAssets,
    fieldType: googleAssetFieldType.LONG_HEADLINE,
    sectionValueKey: LONG_HEADLINES_LIST,
    isInternalAssetGroup,
    assetGroupId,
    initialValues,
    title,
    adAccount
  })

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      isLoadingSelector={isLoadingSelector}
      errorSelector={errorSelector}
      successSubmit={successSubmit}
      clearEditItem={onClearSubmit}
      {...formProps}
    >
      <MultipleOptionsField
        fieldLabel="Long headline"
        fieldMaxLength={longHeadlineMaxLength}
        listFieldName={LONG_HEADLINES_LIST}
        formik={purifiedFormik}
        minListQuantity={2}
      />
    </EditForm>
  )
}

export default LongHeadlinesSectionForm
